export const DEATH_BENEFIT_TYPES = [
  'Death_Natural',
  'Death_Accidental',
  'Death_PreExistingCondition'
]

// Stricter than OMM, which only counts Approved/Approved_Paid: an open death
// claim must block too, or the same death can be lodged twice in parallel.
const CLAIM_STATUSES_THAT_FREE_THE_MEMBER = [
  'Rejected',
  'Discarded',
  'Cancelled',
  'Declined',
  'Withdrawn'
]

export const isDeathBenefit = function (type) {
  return DEATH_BENEFIT_TYPES.indexOf(type) !== -1
}

const claimBenefitTypes = function (claim) {
  const fromUsages = (claim.benefit_usages || []).map(function (usage) {
    return usage && usage.benefit_type
  })
  const fromBenefits = (claim.benefits || []).map(function (benefit) {
    return benefit && benefit.type
  })
  return fromUsages.concat(fromBenefits)
}

export const findExistingDeathClaim = function (claims, policyGuid, dependantGuid) {
  if (!policyGuid || !dependantGuid) return null
  return (claims || []).filter(function (claim) {
    return claim &&
      claim.policy_guid === policyGuid &&
      claim.dependant_guid === dependantGuid &&
      CLAIM_STATUSES_THAT_FREE_THE_MEMBER.indexOf(claim.status) === -1 &&
      claimBenefitTypes(claim).some(isDeathBenefit)
  })[0] || null
}
